import produce from 'immer';
import { first, isNil } from 'lodash-es';
import React from 'react';

import { getIdFromShopifyGraphQLId } from '../../../../utils/shopify';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { CollapedSetUILineItemProperties, SetPricingOptionalProperties } from '../../../../utils/cart';
import { InitialUrlSearchParams, isProduction } from '../../../../utils/environment';
import { notEmpty } from '../../../../utils/typescriptUtils';
import { VariantSelections, VariantSelectionsProps } from '../../components/VariantSelections';
import { ProductData } from '../../types/GraphqlPDPDetailsData';
import { IPdpData, TUserSelections } from '../../types/PDP';
import { computeSetPreviewImages } from '../../utils';

const ForcedMatchingSetTag = 'Policy:ForcedMatchingSet';

// ? [REVISIT] worth also checking if it's a set?
export const isForcedMatchingSet = (tags: string[]) => tags.includes(ForcedMatchingSetTag);

// ? do we need to remove colors with no options in the other "product"s?
export const computeForceMatchingSetVariantSelectionProps = (props: VariantSelectionsProps) =>
  produce(props, (draft) => {
    // ? [REVISIT] make sure this `!` is safe; how do we express this in TS
    draft.pdpData.products = [draft.pdpData.products[0]!];
    draft.userSelections = [draft.userSelections[0]!];
    draft.pdpData.isASet = false;
  });

export const ForcedMatchingSetsVariantSelections: React.FC<VariantSelectionsProps> = (props) => {
  const adjustedProps = computeForceMatchingSetVariantSelectionProps(props);
  const demoForceMatching = !isProduction && !isNil(InitialUrlSearchParams.get('demoForceMatching'));
  return (
    <>
      <VariantSelections {...adjustedProps} />
      {demoForceMatching && <VariantSelections {...props} />}
    </>
  );
};

export const computeForcedMatchingSetsLineItemProperties = (
  pdpData: IPdpData,
  userSelections: TUserSelections
): (CollapedSetUILineItemProperties & SetPricingOptionalProperties) | undefined => {
  const {
    isASet,
    variations: { ForcedMatchingSet },
  } = pdpData;

  const matchingColorSelection = computeSetPreviewImages(pdpData, userSelections);
  const currentSetPreviewImage = first(
    notEmpty(matchingColorSelection) ? matchingColorSelection : pdpData.assets.images
  );
  const discountedSetLines =
    pdpData.pdpProductShell.tags.includes('Policy:DiscountedSet') && pdpData.pdpProductShell.compareAtPrice
      ? { _setStrikeThroughPrice: pdpData.pdpProductShell.compareAtPrice * 100 }
      : undefined;
  const finalProperties =
    isASet && ForcedMatchingSet && currentSetPreviewImage
      ? {
          _setCollapedCartUI: true,
          _setImage: currentSetPreviewImage,
          _setForcedMatchingSets: true,
          ...discountedSetLines,
        }
      : undefined;

  return finalProperties;
};

// very temporary
export const generateHashForLineItemScripts = (productDataGroups: ProductData[][]) => {
  const hash = productDataGroups
    .map((products, outerIndex) =>
      products
        .map((product, innerIndex) => `${getIdFromShopifyGraphQLId(product.id)} => ${outerIndex} #${product.handle}`)
        .join('\n')
    )
    .join('\n\n');

  console.log(hash);
};
